
(function() {
  // We use a small 'lock' variable to prevent flickering
  let lastProcessedPrice = 0;

  setInterval(function() {
    // 1. Target the specific subtotal ID from your Flex Liquid file
    const subtotalEl = document.querySelector('#cart-subtotal-amount');
    const pointsDisplay = document.getElementById('dynamic-points');

    if (subtotalEl && pointsDisplay) {
      // 2. Flex often wraps the price in extra spans, we get the clean text
      // We remove everything except numbers and the decimal point
      const priceText = subtotalEl.textContent || subtotalEl.innerText;
      const cleanPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      
      if (!isNaN(cleanPrice)) {
        const roundedPoints = Math.round(cleanPrice);

        // 3. Only update if the price has actually changed
        if (roundedPoints !== lastProcessedPrice) {
          pointsDisplay.innerText = roundedPoints;
          lastProcessedPrice = roundedPoints;
          
          // Optional: debugging to see it working in the console
          // console.log('Flex Cart Sync: ' + roundedPoints + ' points');
        }
      }
    }
  }, 1000); // Check every second
})();
